module.exports = __webpack_public_path__ + "ace5ac55971885556a812befbf0f3a7a.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_3.png
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_3.png
// module chunks = 40